module.exports = __webpack_public_path__ + "images/893da18d72bd1a8a938388dc1a0beaf5.svg";